<div class="panelbar-wrapper">
	<kendo-panelbar
		(stateChange)="handleStateChange($event)"
		[selectable]="false">
		<kendo-panelbar-item
			*ngFor="let menu of menuitems"
			[id]="menu.path"
			[title]="menu.path"
			[selected]="menu.path === selectedId"
			(click)="onMenuItemClick(menu)">
			<ng-template kendoPanelBarItemTitle>
				<kendo-svgicon [icon]="menu.icon"></kendo-svgicon>
				<span class="underline-space">{{ menu.name }}</span>
			</ng-template>
		</kendo-panelbar-item>
	</kendo-panelbar>
</div>
